import { render, staticRenderFns } from "./ForeignUnder18Modal.vue?vue&type=template&id=64d33245"
import script from "./ForeignUnder18Modal.vue?vue&type=script&lang=js"
export * from "./ForeignUnder18Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports